/* eslint-disable no-unused-vars */
// CSS
import Alpine from "alpinejs";

Alpine.data("dropdown", () => ({
  open: false,

  toggle() {
    if (this.open) {
      return this.close();
    }
    this.$refs.button.focus();
    this.open = true;
  },

  close(focusAfter) {
    if (!this.open) return;
    this.open = false;
    focusAfter && focusAfter.focus();
  },
}));

Alpine.data("chapters", () => ({
  init() {
    this.getChapterCount();
  },
  allRegions: [],
  selectedRegions: [],
  chapters: [],
  chapterCount: 0,
  searchTerm: "*",
  showLoader: "hidden",
  /**
   * Pagination
   */
  offSet: 0,
  pageLinks: [],
  currentPage: 1,
  pageSize: 8,
  lastPage: 0,

  scrollToListTop() {
    this.$refs.listTop.scrollIntoView({ block: "start" });
  },

  prevPage() {
    this.currentPage -= 1;
    this.offSet -= this.pageSize;
    this.getChapters();
    this.getPageLinks();
    this.scrollToListTop();
  },
  nextPage() {
    this.currentPage += 1;
    this.offSet += this.pageSize;
    this.getChapters();
    this.getPageLinks();
    this.scrollToListTop();
  },
  goToPage(page) {
    this.offSet = this.pageSize * (page - 1);
    this.currentPage = page;
    this.getPageLinks();
    this.getChapters();
    this.scrollToListTop();
  },
  getPageLinks() {
    const allLinks = [...Array(this.lastPage).keys()].map((el) => el + 1);
    if (this.lastPage <= 4) {
      this.pageLinks = allLinks;
    } else {
      const alwaysDisplay = [
        1,
        this.lastPage,
        this.currentPage,
        this.currentPage + 1,
        this.currentPage - 1,
      ];
      const pageLinkArray = allLinks.filter((link) => {
        if (alwaysDisplay.includes(link)) return link;
      });
      this.pageLinks = pageLinkArray;
    }
  },
  addClasses(page) {
    if (page === this.currentPage) return "current-page";
    if (this.lastPage > 4) {
      if (page === this.currentPage + 1 && page + 2 <= this.lastPage)
        return "ellipsis_after";
      if (page === 1 && this.currentPage > 3) return "ellipsis_after";
    }
  },
  /**
   * Filters
   */
  setRegions(data) {
    const allRegions = data.reduce((arr, item) => {
      const newRegion = {
        title: item.title,
        description: item.description,
      };
      arr.push(newRegion);
      return arr;
    }, []);
    this.allRegions = allRegions;
    this.selectedRegions = [];
  },
  getResultsCountBlurb() {
    if (this.chapterCount === 0) {
      return "Showing 0 chapters.";
    }
    if (this.chapterCount === 1) {
      return `Showing 1 chapter.`;
    }
    if (this.chapterCount <= this.pageSize) {
      return `Showing ${this.chapterCount} chapters.`;
    }
    let endRange = this.offSet + this.pageSize;
    if (endRange > this.chapterCount) {
      endRange = this.chapterCount;
    }
    return `Showing ${this.offSet + 1} to ${endRange} of ${
      this.chapterCount
    } chapters.`;
  },
  getCheckedRegion(cat) {
    const iconClass = this.selectedCategories.includes(cat)
      ? "check_box"
      : "check_box_outline_blank";
    return `
      <div class="w-full flex flex-row gap-x-6">
        <div class="material-icons-round align-baseline">${iconClass}</div>
        <div class="block">${cat}</div>
      </div>`;
  },
  isSelected(title) {
    if (this.selectedRegions.length) {
      return this.selectedRegions[0] == title;
    } else {
      return false;
    }
  },
  getRegionButtonText() {
    const icon = `<span class="material-icons-round">
    keyboard_arrow_down
    </span>`;
    if (this.selectedRegions.length) {
      return `${this.selectedRegions[0]}${icon}`;
    } else {
      return `All Regions${icon}`;
    }
  },
  regionSelectAllText() {
    if (this.selectedRegions.length) {
      return "Show All Regions";
    } else {
      return "Showing All Regions";
    }
  },

  selectAllRegions() {
    if (this.selectedRegions.length) {
      this.selectedRegions = [];
      this.currentPage = 1;
      this.offSet = 0;
      this.getChapterCount();
      this.getChapters();
      this.close();
    }
  },
  toggleSelectedRegion(cat) {
    this.selectedRegions = [cat];
    this.currentPage = 1;
    this.offSet = 0;
    this.getChapterCount();
    this.getChapters();
    this.close();
  },

  /**
   * Spinning Loader
   */
  initialRenderStillPresent: true,
  clearInitial() {
    if (this.initialRenderStillPresent) {
      this.$refs.initialChapters.remove();
      this.initialRenderStillPresent = false;
    }
  },

  /**
   * API Calls
   */
  async getChapters() {
    this.showLoader = "visible";
    const query = `
    query ($pageSize: Int, $offSet: Int, $regions: [String]) {
      entries(
        section: "chapters"
        limit: $pageSize
        offset: $offSet
        relatedToCategories: {group: "regions", title: $regions}
        orderBy: "title ASC"
      ) {
        title
        url
        ... on chapters_chapter_Entry {
          website
          phoneNumber
          chapterEmail
          address
          city
          postalCode
          chapPresident {
            title
            ... on directory_default_Entry {
              contactEmail
            }
          }
          state {
            ... on states_Category {
              stateCode
            }
          }
          newsManager {
            title
            ... on directory_default_Entry {
              contactEmail
            }
          }
          chapterImage(limit: 1) {
            url(transform: "cardLarge")
            webp: url(transform: "cardLargeWebp")
          }
        }
      }
    }
      
    `;
    const variables = {
      regions: this.selectedRegions,
      pageSize: this.pageSize,
      offSet: this.offSet,
    };

    fetch("/api", {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer m0624oThl9zQDhw9Q3Zsahau1EzlOaj8",
      },
      body: JSON.stringify({ query, variables }),
    })
      .then((res) => res.json())
      .then((result) => {
        const newData = result.data.entries.reduce((arr, item) => {
          const newCleaned = {
            title: item.title,
            website: item.website,
            chapterEmail: item.chapterEmail,
            phoneNumber: item.phoneNumber,
            address: item.address,
            city: item.city,
            stateCode: item.state.length ? item.state[0].stateCode : null,
            postalCode: item.postalCode,
            imageUrl: item.chapterImage.length
              ? item.chapterImage[0].url
              : null,
            webpUrl: item.chapterImage.length
              ? item.chapterImage[0].webp
              : null,
            newsManagerTitle: item.newsManager.length
              ? item.newsManager[0].title
              : null,
            newsManagerEmail: item.newsManager.length
              ? item.newsManager[0].contactEmail
              : null,
            chapPresidentTitle: item.chapPresident.length
              ? item.chapPresident[0].title
              : null,
            chapPresidentEmail: item.chapPresident.length
              ? item.chapPresident[0].contactEmail
              : null,
          };
          arr.push(newCleaned);
          return arr;
        }, []);
        this.clearInitial();
        this.chapters = newData;
        this.showLoader = "hidden";
      })
      .catch((error) => console.log(error));
  },
  async getChapterCount() {
    const query = `query ($regions: [String]) {
      entryCount(
        section: "chapters"
        relatedToCategories: {group: "regions", title: $regions}
      )
    }
    `;
    const variables = {
      regions: this.selectedRegions,
    };

    fetch("/api", {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer m0624oThl9zQDhw9Q3Zsahau1EzlOaj8",
      },
      body: JSON.stringify({ query, variables }),
    })
      .then((res) => res.json())
      .then((result) => {
        this.chapterCount = result.data.entryCount;
        this.lastPage = Math.ceil(this.chapterCount / this.pageSize);
        this.getPageLinks();
      })
      .catch((error) => console.log(error));
  },
  async getRegions() {
    const query = `query {
      categories(group: "regions") {
        title
        ... on regions_Category {
          description
        }
      }
    }
    `;

    fetch("/api", {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer m0624oThl9zQDhw9Q3Zsahau1EzlOaj8",
      },
      body: JSON.stringify({ query }),
    })
      .then((res) => res.json())
      .then((result) => {
        this.allRegions = result.data.categories;
      })
      .catch((error) => console.log(error));
  },
}));

Alpine.start();
